import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from "rxjs";

/**
 * Passes on the KeyCloak token
 */
export const languageInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const translateService: TranslateService = inject(TranslateService);
  const language = translateService.getCurrentLang();
  if (!language) {
    return next(request);
  }
  const clone = request.clone({
    setHeaders: { 'Accept-Language': language }
  });
  return next(clone);
};
